import React from 'react';
import SearchInput from '../../../components/SearchInput';
import MyButton from '../../../components/MyButton';

function HoldingDatesSection({
  dates,
  time,
  onDatesChange,
  onTimeChange,
  legacyHoldingDate,
  dateStart,
  dateEnd,
  onDateStartChange,
  onDateEndChange,
}) {
  const filledCount = dates.filter(Boolean).length;
  const hasMultipleDays = filledCount > 1;

  const updateDateAt = (index, value) => {
    const next = dates.map((item, i) => (i === index ? value : item));
    onDatesChange(next);
  };

  const addDate = () => {
    onDatesChange([...dates, '']);
  };

  const removeDate = (index) => {
    if (dates.length <= 1) {
      onDatesChange(['']);
      return;
    }
    onDatesChange(dates.filter((_, i) => i !== index));
  };

  const handleTimeChange = (value) => {
    const next = typeof value === 'string' ? value : (value?.target?.value ?? '');
    onTimeChange(next, true);
  };

  return (
    <div className="add_event_dates_block">
      <p className="add_event_dates_block_title">Даты и сроки</p>
      <p className="add_event_dates_block_lead">
        Здесь задаются дни проведения, общее время и служебные даты для сортировки и активности в приложении.
      </p>

      <div className="add_event_dates_block_section">
        <p className="add_event_dates_block_section_title">Дни проведения</p>
        <p className="add_event_dates_block_hint">
          Добавьте один или несколько дней. Их можно удалять и дописывать.
        </p>

        {legacyHoldingDate ? (
          <p className="add_event_dates_block_legacy">
            Ранее дата была указана текстом: «
            {legacyHoldingDate}
            ». Добавьте конкретные дни ниже — они станут основным источником дат.
          </p>
        ) : null}

        {dates.map((dateValue, index) => (
          <div className="add_event_dates_block_row" key={`holding-date-${index}`}>
            <SearchInput
              wrapperClassName="add_event_container_form_input add_event_dates_block_date_input"
              placeholder={`День ${index + 1}`}
              withLeftIcon={false}
              withCloseIcon={false}
              value={dateValue}
              onChange={(e) => updateDateAt(index, e?.target?.value || '')}
              shouldValueConsiderAsFocus={false}
              type="date"
            />
            {dates.length > 1 ? (
              <button
                type="button"
                className="add_event_dates_block_remove"
                onClick={() => removeDate(index)}
              >
                Удалить
              </button>
            ) : null}
          </div>
        ))}

        <MyButton
          text="Добавить день"
          onClick={addDate}
          secondary
          className="add_event_dates_block_add"
        />

        <SearchInput
          wrapperClassName="add_event_container_form_input"
          placeholder="Время (необязательно)"
          withLeftIcon={false}
          value={time}
          onChange={handleTimeChange}
          shouldValueConsiderAsFocus={false}
          isTimeInput
        />

        {hasMultipleDays ? (
          <p className="add_event_dates_block_label">
            Несколько дней: одно время применится ко всем одинаково.
            Если у дней разное время — оставьте поле пустым и опишите расписание в описании.
          </p>
        ) : (
          <p className="add_event_dates_block_label">
            Для одного дня можно указать время начала. Если дней станет несколько, то же время
            применится ко всем. Разное время по дням лучше не задавать здесь — оставьте поле пустым
            и укажите детали в описании.
          </p>
        )}
      </div>

      <div className="add_event_dates_block_divider" />

      <div className="add_event_dates_block_section">
        <p className="add_event_dates_block_section_title">Сортировка и активность</p>
        <p className="add_event_dates_block_hint">
          Эти поля не заменяют дни проведения выше — они только влияют на порядок и «протухание» в приложении.
        </p>

        <SearchInput
          wrapperClassName="add_event_container_form_input"
          placeholder="Дата начала"
          withLeftIcon={false}
          value={dateStart}
          onChange={onDateStartChange}
          shouldValueConsiderAsFocus={false}
          type="date"
          withCloseIcon={false}
        />
        <p className="add_event_dates_block_label">
          Дата начала. Влияет на сортировку. Оставьте пустым, чтобы мероприятие не сортировалось и было сверху.
        </p>

        <SearchInput
          wrapperClassName="add_event_container_form_input"
          placeholder="Дата завершения"
          withLeftIcon={false}
          value={dateEnd}
          onChange={onDateEndChange}
          shouldValueConsiderAsFocus={false}
          type="date"
          withCloseIcon={false}
        />
        <p className="add_event_dates_block_label">
        Дата завершения. Влияет на проверку, истекло ли мероприятие. Оставьте пустым, чтобы оно никогда не уходило в неактивные.
        </p>
      </div>
    </div>
  );
}

export default HoldingDatesSection;
